import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import PageInfo from './PageInfo';
import Icon from 'components/ui/Icon';
import { getObject, isCurrentPageHome, getCurrentPageDraftDoc } from 'services/app/selectors';
import { ADMIN_ACCENT_PRIMARY, ADMIN_SURFACE_6 } from 'style/constants';

interface NavigationButtonProps {
  isActive: boolean;
  onClick: () => void;
}

export default function({
  isActive,
  onClick,
}: NavigationButtonProps) {
  const page = useSelector(getObject);
  const isHome = useSelector(isCurrentPageHome);
  const hasChanges = !!useSelector(getCurrentPageDraftDoc);

  if (!page) {
    return null;
  }

  return (
    <NavigationButton onClick={onClick} data-testid="channelDropdown">
      <PageInfo
        hasChanges={hasChanges}
        image={page.data?.channelSelectActiveImageUrl || null}
        isHome={isHome}
        name={page.seo?.title || page.data?.name || page.slug}
        pageId={page._id}
        tooltipPosition="bottom"
        type={page.type}
      />
      <ArrowIcon pointUp={isActive} />
    </NavigationButton>
  );
}

const NavigationButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 30vw;
  max-width: 350px;
  padding: 0 20px;
  height: 100%;
  border-right: 1px solid ${ADMIN_SURFACE_6};
  && {
    cursor: pointer;
  }
`;

const ArrowIcon = styled(Icon).attrs(props => ({
  color: ADMIN_ACCENT_PRIMARY(props),
  name: 'navArrow',
}))<{pointUp?: boolean}>`
  display: flex;
  transition: transform 0.5s;
  transform: rotate(${({ pointUp }) => pointUp ? 90 : -90}deg);
  & > svg {
    width: 7px;
    height: 13px;
  }
`;
